import { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { autorun } from 'mobx'
import { observer } from 'mobx-react'
import { Dropdown } from 'antd'
import { EasyIcon } from 'src/components'
import ChangePassword from './ChangePassword'
import { mainStore } from 'enasops/stores'
import { $consts } from 'src/plugins'
import { useEvt } from 'src/hooks'

const User = () => {
  const navigate = useNavigate()

  useEvt($consts['EVT/LOGIN_EXPIRED'], () => {
    mainStore.logout()
  })

  useEffect(() => autorun(() => {
    !mainStore.isLogin && navigate($consts['ROUTE/LOGIN'])
  }), [])

  const [visible, setVisible] = useState(false)

  const overlay = useMemo(() => {
    const handleLogout = () => {
      mainStore.logout()
    }

    const { userinfo } = mainStore
    return {
      items: [
        { key: 'user-menu-userinfo', label: `当前登录：${userinfo.CODE}` },
        { key: 'user-menu-change-password', label: <ChangePassword /> },
        { key: 'user-menu-logout', label: '退出登录' },
      ],
      onClick: (evt: any) => {
        switch (evt.key) {
          case 'user-menu-logout':
            handleLogout()
            break
          default:
            break
        }
        setVisible(false)
      }
    }
  }, [mainStore.userinfo.CODE])

  return (
    <Dropdown
      open={visible}
      onOpenChange={setVisible}
      menu={overlay}
    >
      <EasyIcon type='UserOutlined' />
    </Dropdown>
  )
}

export default observer(User)